var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35.99 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: teal;\n        stroke-miterlimit: 10;\n        stroke-width: 3px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "livetype"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18,1.5c.32,0,.63,.07,.92,.2l12.94,5.49c1.51,.64,2.64,2.13,2.63,3.93-.03,6.82-2.84,19.29-14.68,24.96-1.15,.55-2.48,.55-3.63,0C4.34,30.42,1.53,17.94,1.5,11.12c0-1.8,1.12-3.29,2.63-3.93L17.08,1.7c.28-.13,.6-.2,.91-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18,24.33c1.48,0,2.74-.52,3.78-1.56,1.04-1.04,1.55-2.3,1.55-3.78s-.52-2.74-1.56-3.78c-1.04-1.04-2.3-1.55-3.78-1.55s-2.74,.52-3.78,1.56c-1.04,1.04-1.55,2.3-1.55,3.78s.52,2.74,1.56,3.78c1.04,1.04,2.3,1.55,3.78,1.55Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.d3e1b52c7a053d6c9ea13619f4bbbd29.svg";
export { ForwardRef as ReactComponent };